var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"svg-icon",style:(`width:${_vm.size}px`),domProps:{"innerHTML":_vm._s(require(`@/assets/svg/icon-${_vm.icon}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }